import React from "react";
import { Snackbar, SnackbarContent, Box, Typography } from "@mui/material";

import warningIcon from "../../../images/warning.svg";
import successIcon from "../../../images/success.svg";

const statusConfig = {
  warning: {
    backgroundColor: "#F4EC5A",
    color: "#5C4600",
    borderColor: "#9A6400",
    icon: warningIcon,
    titleColor: "#1D192B",
    bodyColor: "#1D192B",
  },
  success: {
    backgroundColor: "#DFF5E1",
    color: "#1B5E20",
    borderColor: "#81C784",
    icon: successIcon,
    titleColor: "#1B5E20",
    bodyColor: "#2E7D32",
  },
};

const StatusSnackbar = ({ open, onClose, type = "warning", title, message }) => {
  const config = statusConfig[type];

  return (
    <Snackbar open={open} onClose={onClose} anchorOrigin={{ vertical: "top", horizontal: "right" }} autoHideDuration={3000} sx={{ zIndex: 1300 }}>
      <SnackbarContent
        sx={{
          backgroundColor: config.backgroundColor,
          color: config.color,
          border: `1px solid ${config.borderColor}`,
          boxShadow: 4,
          borderRadius: "8px",
          pl: 2,
          pr: 8,
        }}
        message={
          <Box display="flex" alignItems="flex-start">
            <img src={config.icon} alt={`${type} icon`} width={18} height={18} style={{ marginTop: 3, marginRight: 6 }} />
            <Box>
              <Typography fontWeight={600} fontSize={16} color={config.titleColor}>
                {title}
              </Typography>
              <Typography fontSize={14} color={config.bodyColor}>
                {message}
              </Typography>
            </Box>
          </Box>
        }
      />
    </Snackbar>
  );
};

export default StatusSnackbar;
